import React from 'react';
import { Link } from 'react-router';

import Translate from 'react-translate-component';

class LoyaltyPointsDescription extends React.Component {
  render () {
    return (<div className='loyalty-description-container'>
      <Translate className='loyalty-description-title' content='LOYALTY_HOW_TO_TITLE' />
      <Translate className='loyalty-description-text' content='LOYALTY_HOW_TO_DESCRIPTION' />
      <Link to='https://www.frilansfinans.se/together-ett-lojalitetsprogram/' target='_blank'>
        <Translate className='loyalty-description-link' content='LOYALTY_HOW_TO_LINK' />
      </Link>
    </div>);
  }
}

export default LoyaltyPointsDescription;



/** WEBPACK FOOTER **
 ** ./src/views/loyalty-program/description.js
 **/